import React from "react";

import Common from "./Common";
const StandarDetail = (props) => {
  return (
    <>
      <Common {...props} />
    </>
  );
};

export default StandarDetail;
